/**
 * WOD3D — translate ACO (and light chrome) without opening each app admin screen.
 * ACO reads window.aco_appMeta.translatted_sett[locale] when the URL locale matches Shopify.locale.
 * We also force-apply strings for the active locale and rewrite hardcoded modal buttons.
 */
(function () {
  if (window.__wod3dAppI18n) return;
  window.__wod3dAppI18n = true;

  const PACKS = {
    en: {
      cart_edit_text: 'Edit',
      price_prefix: 'From',
      options_price_label: 'Personalization / Adaptation',
      product_group_sold_out_text: 'Sold out',
      add_to_cart_text: 'Personalize',
      strings: {
        file_button_text: 'Choose file',
        file_placeholder: '{count} files',
        file_droppable_action_text: 'Browse',
        file_droppable_desc_text: 'or {action} to choose a file',
        file_droppable_text: 'Drag and drop files here',
        file_upload_completed: 'Completed',
        other: 'Other',
        clearSelection: 'Clear',
        repeater_add: 'Add field',
        repeater_remove: 'Remove field',
        add_to_cart_text: 'Personalize',
      },
      validation_messages: {
        formError: 'Please fix the errors shown above',
        patternError: 'Pattern does not match',
        groupMaxError: 'Maximum value is %s',
        groupMinError: 'Minimum value is %s',
        maxValueError: 'Maximum value is %s',
        minValueError: 'Minimum value is %s',
        requiredError: 'Required field',
        uploadPending: 'Files are still uploading',
        validUrlError: 'Please provide a valid URL',
        maxFieldsError: 'Select maximum %s fields',
        maxlengthError: 'Maximum %s characters allowed',
        minFieldsError: 'Select minimum %s fields',
        minlengthError: 'At least %s characters required',
        charleftMessage: '%s characters left',
        otherFieldError: 'Another value is required',
        validEmailError: 'Please provide a valid email address',
        maxFileSizeError: 'Maximum file size must be %s',
        maxQuantityError: 'Maximum quantity allowed: %s',
        minFileSizeError: 'Minimum file size must be %s',
        minQuantityError: 'Minimum quantity required: %s',
        allowedCharsError: 'Characters %s are not supported',
        maxFileCountError: 'Maximum %s files allowed',
        minFileCountError: 'Minimum %s files required',
        fileExtensionError: 'File type is not supported',
        quantityRequiredError: 'Please enter a valid quantity',
      },
      modal: { save: 'Save changes', cancel: 'Cancel' },
      labels: {
        'No': 'No',
        'Sí': 'Yes',
        'SÍ': 'YES',
        'Oro': 'Gold',
        'Azul': 'Blue',
        'Base': 'Base',
        'Beso': 'Kiss',
        'Flor': 'Flower',
        'Gris': 'Grey',
        'Luna': 'Moon',
        'Nube': 'Cloud',
        'Otra': 'Other',
        'Otro': 'Other',
        'OTRO': 'OTHER',
        'Pato': 'Duck',
        'Peso': 'Weight',
        'Piña': 'Pineapple',
        'Puño': 'Fist',
        'Rayo': 'Lightning',
        'Reno': 'Reindeer',
        'Roja': 'Red',
        'Rojo': 'Red',
        'Rosa': 'Pink',
        'Color': 'Color',
        'Comba': 'Jump rope',
        'Forma': 'Shape',
        'Fresa': 'Strawberry',
        'Gorro': 'Hat',
        'Hueso': 'Bone',
        'Icono': 'Icon',
        'Letra': 'Letter',
        'Negra': 'Black',
        'Negro': 'Black',
        'Notas': 'Notes',
        'Plata': 'Silver',
        'Pulpo': 'Octopus',
        'Tacón': 'High heel',
        'Texto': 'Text',
        'Total': 'Total',
        'Verde': 'Green',
        'Árbol': 'Tree',
        '1º PTO': '1st place',
        '2º PTO': '2nd place',
        '3º PTO': '3rd place',
        'Anilla': 'Ring',
        'Blanca': 'White',
        'Blanco': 'White',
        'Bronce': 'Bronze',
        'Cactus': 'Cactus',
        'Carita': 'Smiley',
        'Cohete': 'Rocket',
        'Concha': 'Shell',
        'Copito': 'Snowflake',
        'Corona': 'Crown',
        'Delfín': 'Dolphin',
        'Dorada': 'Gold',
        'Editar': 'Edit',
        'España': 'Spain',
        'Estilo': 'Style',
        'Flecha': 'Arrow',
        'Grande': 'Large',
        'Italia': 'Italy',
        'Marrón': 'Brown',
        'Modelo': 'Model',
        'Morada': 'Purple',
        'Morado': 'Purple',
        'Nombre': 'Name',
        'Pareja': 'Pair',
        'Sandía': 'Watermelon',
        'Tamaño': 'Size',
        'Trébol': 'Clover',
        'Agotado': 'Sold out',
        'Ballena': 'Whale',
        'Bandera': 'Flag',
        'Cerveza': 'Beer',
        'Chupete': 'Pacifier',
        'Ciruela': 'Plum',
        'Colores': 'Colors',
        'Corazón': 'Heart',
        'Francia': 'France',
        'Galicia': 'Galicia',
        'Galleta': 'Cookie',
        'Iguales': 'Same',
        'Lobezno': 'Wolverine',
        'Naranja': 'Orange',
        'Palmera': 'Palm tree',
        'Pequeña': 'Small',
        'Pequeño': 'Small',
        'Plátano': 'Banana',
        'Puñitos': 'Fists',
        'Redondo': 'Round',
        'Resumen': 'Summary',
        'Texto 1': 'Text 1',
        'Texto 2': 'Text 2',
        'Texto 3': 'Text 3',
        'Texto 4': 'Text 4',
        'Texto 5': 'Text 5',
        'Texto 6': 'Text 6',
        'Texto 7': 'Text 7',
        'Texto 8': 'Text 8',
        'Texto 9': 'Text 9',
        'Tiburón': 'Shark',
        'Aguacate': 'Avocado',
        'Amarilla': 'Yellow',
        'Amarillo': 'Yellow',
        'Cabeza A': 'Head A',
        'Cabeza B': 'Head B',
        'Calabaza': 'Pumpkin',
        'Cataluña': 'Catalonia',
        'Chip NFC': 'NFC chip',
        'Cuadrado': 'Square',
        'Estrella': 'Star',
        'Estándar': 'Standard',
        'Nombre 1': 'Name 1',
        'Nombre 2': 'Name 2',
        'Objetivo': 'Target',
        'Plateada': 'Silver',
        'Texto 10': 'Text 10',
        'Tu charm': 'Your charm',
        'TU TEXTO': 'YOUR TEXT',
        'Turquesa': 'Turquoise',
        'Andalucía': 'Andalusia',
        'Azul cian': 'Cyan blue',
        'Clave sol': 'Treble clef',
        'Feminista': 'Feminist',
        'Gafas sol': 'Sunglasses',
        'Gris 36KG': 'Grey 36KG',
        'Iniciales': 'Initials',
        'Marihuana': 'Cannabis',
        'Rojo 32KG': 'Red 32KG',
        'Rosa palo': 'Pale pink',
        'Zanahoria': 'Carrot',
        'Azul cielo': 'Sky blue',
        'Diferentes': 'Different',
        'Individual': 'Individual',
        'Murciélago': 'Bat',
        'País Vasco': 'Basque Country',
        'Superhéroe': 'Superhero',
        'Texto base': 'Base text',
        'Texto tapa': 'Lid text',
        'Azul oscuro': 'Dark blue',
        'Blanco 40KG': 'White 40KG',
        'Cabezas A/B': 'Heads A/B',
        'Color letra': 'Letter color',
        'Morado 20KG': 'Purple 20KG',
        'Peso+Nombre': 'Weight+Name',
        'Pintalabios': 'Lipstick',
        'Rosa fucsia': 'Fuchsia pink',
        'Rosa sakura': 'Sakura pink',
        'Texto/frase': 'Text/phrase',
        'Verde bambú': 'Bamboo green',
        'Verde menta': 'Mint green',
        'Ciruela 32KG': 'Plum 32KG',
        'Color ribete': 'Trim color',
        'Flecha Verde': 'Green Arrow',
        'Marrón latte': 'Latte brown',
        'Naranja 28KG': 'Orange 28KG',
        'Personalizar': 'Personalize',
        'Púrpura lila': 'Lilac purple',
        'Amarillo 16KG': 'Yellow 16KG',
        'Azul turquesa': 'Turquoise blue',
        'Color mitad 1': 'Color half 1',
        'Color mitad 2': 'Color half 2',
        'MUJER + MUJER': 'WOMAN + WOMAN',
        'Parte trasera': 'Back',
        'Texto mitad 1': 'Text half 1',
        'Texto mitad 2': 'Text half 2',
        'Texto trasero': 'Back text',
        'Turquesa 12KG': 'Turquoise 12KG',
        'Amarillo limón': 'Lemon yellow',
        'Azul cian 12KG': 'Cyan blue 12KG',
        'Base del mango': 'Handle base',
        'Color del logo': 'Logo color',
        'Elegir archivo': 'Choose file',
        'Linterna Verde': 'Green Lantern',
        'MUJER + HOMBRE': 'WOMAN + MAN',
        'Rojo escarlata': 'Scarlet red',
        'Rosa Brillante': 'Bright pink',
        'Texto inferior': 'Bottom text',
        'Texto superior': 'Top text',
        'Verde muérdago': 'Mistletoe green',
        'Verde turquesa': 'Turquoise green',
        'Campo requerido': 'Required field',
        'Capitán América': 'Captain America',
        'Color del icono': 'Icon color',
        'Color del texto': 'Text color',
        'HOMBRE + HOMBRE': 'MAN + MAN',
        'Imagen del logo': 'Logo image',
        'Max. 1 caracter': 'Max. 1 character',
        'Max. 2 caracter': 'Max. 2 characters',
        'Parte delantera': 'Front',
        'Rosa fucsia 8KG': 'Fuchsia pink 8KG',
        'Rosa sakura 8KG': 'Sakura pink 8KG',
        'Texto delantero': 'Front text',
        'Verde Brillante': 'Bright green',
        'Verde brillante': 'Bright green',
        'Azul oscuro 12KG': 'Dark blue 12KG',
        'Color de la base': 'Base color',
        'Color del cuerpo': 'Body color',
        'Elige tu opción:': 'Choose your option:',
        'Estilo del texto': 'Text style',
        'Forma del cuerpo': 'Body shape',
        'Galicia Estelada': 'Galicia Estelada',
        'Verde bambú 24KG': 'Bamboo green 24KG',
        'Verde menta 24KG': 'Mint green 24KG',
        'Max. 2 caracteres': 'Max. 2 characters',
        'Max. 3 caracteres': 'Max. 3 characters',
        'Max. 6 caracteres': 'Max. 6 characters',
        'Max. 7 caracteres': 'Max. 7 characters',
        'Max. 8 caracteres': 'Max. 8 characters',
        'Max. 9 caracteres': 'Max. 9 characters',
        'Máx. 3 caracteres': 'Max. 3 characters',
        'Máx. 7 caracteres': 'Max. 7 characters',
        'Naranja mandarina': 'Tangerine orange',
        'Nombre del peludo': 'Pet’s name',
        'Especifica el peso': 'Specify the weight',
        'Max. 10 caracteres': 'Max. 10 characters',
        'Max. 12 caracteres': 'Max. 12 characters',
        'Max. 20 caracteres': 'Max. 20 characters',
        'Máx. 12 caracteres': 'Max. 12 characters',
        'Máx. 50 caracteres': 'Max. 50 characters',
        'Número de teléfono': 'Phone number',
        'Peso personalizado': 'Custom weight',
        'Precio del producto': 'Product price',
        'Texto personalizado': 'Custom text',
        'Iniciales o números.': 'Initials or numbers.',
        'Texto/nombre trasero': 'Back text/name',
        '¿Quieres más charms?': 'Want more charms?',
        'Texto/nombre delantero': 'Front text/name',
        'Una letra o un número.': 'A letter or a number.',
        'Forma del marco del ojo': 'Eye frame shape',
        '¿Qué icono te gustaría?': 'Which icon would you like?',
        'Peso/color personalizado': 'Custom weight/color',
        'El texto irá en mayúsculas': 'Text will be in uppercase',
        'Situado bajo el código QR.': 'Placed under the QR code.',
        'Tus iniciales o un número.': 'Your initials or a number.',
        'Personalización / Adaptación': 'Personalization / Adaptation',
        '¡Un charm para cada ocasión!': 'A charm for every occasion!',
        '¿Quieres colores diferentes?': 'Want different colors?',
        '¿Quieres otro par de discos?': 'Want another pair of plates?',
        'Foto, ilustración o referencia': 'Photo, illustration or reference',
        'Un nombre, nombre del equipo...': 'A name, team name...',
        'Sube el logo de tu empresa/marca': 'Upload your company/brand logo',
        '¿Quieres personalizar tu lloratida?': 'Want to personalize your “lloradita”?',
        '¡Personalízalos! Pueden ser diferentes.': 'Personalize them! They can be different.',
        '¿Quieres texto encima y debajo de tu marca?': 'Want text above and below your brand?',
        'Grabado en la parte de atrás, sobre el color.': 'Engraved on the back, over the color.',
        'Selecciona el color en el que irá la inicial.': 'Select the color for the initial.',
        'El nombre irá en la parte trasera de la kettlel.': 'The name goes on the back of the kettlebell.',
        'Enlace a tu web, red social, WhatsApp, llamada...': 'Link to your website, social, WhatsApp, call...',
        'Cuéntanos cualquier detalle sobre tu diseño (opcional)': 'Tell us any detail about your design (optional)',
        'Impreso en la parte de atrás de la inicial, bien visible.': 'Printed on the back of the initial, clearly visible.',
        'El nombre irá bajo relieve en la parte delantera de la inicial.': 'The name will be embossed on the front of the initial.',
        'Elige si quieres un llavero individual o un set para compartir.': 'Choose whether you want a single keychain or a set to share.',
        '👉 Puedes enviarnos cualquier imagen o idea. Nosotros la adaptamos.': 'You can send any image or idea. We’ll adapt it.',
        'Selecciona si las dos caras del disco son iguales o quieres textos diferentes.': 'Choose whether both sides of the plate are the same or you want different texts.',
        'Incluye 2 charms a tu gusto. ¿Quieres más? ¡Elige los que quieras y hazlo único!': 'Includes 2 charms of your choice. Want more? Pick as many as you like and make it unique!',
        'Icono simple y claro, pensado para identificarse de un vistazo, como los anteriores.': 'A simple, clear icon meant to be recognized at a glance, like the ones above.',
        'El color condiciona el peso, si quieres un peso diferente, elige "Peso personalizado".': 'Color determines the weight; if you want a different weight, choose "Custom weight".',
        'Importante: Por motivos de calidad de la pieza, el logo ha de ser lo más simple posible.': 'Important: For piece quality, the logo must be as simple as possible.',
        'Selecciona si las dos cabezas de la dumbbell son iguales o quieres iniciales diferentes.': 'Choose whether both dumbbell heads are the same or you want different initials.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.': 'Enter the link to your website, social profile, phone number or business address.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.<br><br>': 'Enter the link to your website, social profile, phone number or business address.<br><br>',
        'El color condiciona el peso, si quieres un peso diferente u otros colores, selecciona "Sí" en "Peso/color personalizado".': 'Color determines the weight; if you want a different weight or other colors, select "Yes" under "Custom weight/color".',
        '¿Quieres el mismo texto para todos los posavasos con los discos de haltero estándar  o por el contrario quieres tus posavasos custom total?': 'Want the same text on all coasters with standard weightlifting plates, or fully custom coasters instead?',
        'Con la tecnología NFC solo necesitas balancear este llavero cerca de tu móvil y ¡zas! Comparte tu página web, tu red social, tu número de teléfono o dirección.': 'With NFC, just hold this keychain near your phone and boom! Share your website, social profile, phone number or address.',
      },
    },
    'pt-PT': {
      cart_edit_text: 'Editar',
      price_prefix: 'Desde',
      options_price_label: 'Personalização / Adaptação',
      product_group_sold_out_text: 'Esgotado',
      add_to_cart_text: 'Personalizar',
      strings: {
        file_button_text: 'Escolher ficheiro',
        file_placeholder: '{count} ficheiros',
        file_droppable_action_text: 'Procurar',
        file_droppable_desc_text: 'ou {action} para escolher um ficheiro',
        file_droppable_text: 'Arrasta e larga os ficheiros aqui',
        file_upload_completed: 'Concluído',
        other: 'Outros',
        clearSelection: 'Limpar',
        repeater_add: 'Adicionar campo',
        repeater_remove: 'Remover campo',
        add_to_cart_text: 'Personalizar',
      },
      validation_messages: {
        formError: 'Corrige os erros mostrados acima',
        patternError: 'O padrão não corresponde',
        groupMaxError: 'O valor máximo é %s',
        groupMinError: 'O valor mínimo é %s',
        maxValueError: 'O valor máximo é %s',
        minValueError: 'O valor mínimo é %s',
        requiredError: 'Campo obrigatório',
        uploadPending: 'Os ficheiros ainda estão a carregar',
        validUrlError: 'Indica um URL válido',
        maxFieldsError: 'Seleciona no máximo %s campos',
        maxlengthError: 'São permitidos no máximo %s caracteres',
        minFieldsError: 'Seleciona no mínimo %s campos',
        minlengthError: 'São necessários pelo menos %s caracteres',
        charleftMessage: '%s caracteres restantes',
        otherFieldError: 'É necessário outro valor',
        validEmailError: 'Indica um email válido',
        maxFileSizeError: 'O tamanho máximo do ficheiro deve ser %s',
        maxQuantityError: 'Quantidade máxima permitida: %s',
        minFileSizeError: 'O tamanho mínimo do ficheiro deve ser %s',
        minQuantityError: 'Quantidade mínima necessária: %s',
        allowedCharsError: 'Os caracteres %s não são compatíveis',
        maxFileCountError: 'Máximo de %s ficheiros permitidos',
        minFileCountError: 'Mínimo de %s ficheiros necessários',
        fileExtensionError: 'O tipo de ficheiro não é compatível',
        quantityRequiredError: 'Introduz uma quantidade válida',
      },
      modal: { save: 'Guardar alterações', cancel: 'Cancelar' },
      labels: {
        'No': 'Não',
        'Sí': 'Sim',
        'SÍ': 'SIM',
        'Oro': 'Ouro',
        'Azul': 'Azul',
        'Base': 'Base',
        'Beso': 'Beijo',
        'Flor': 'Flor',
        'Gris': 'Cinzento',
        'Luna': 'Lua',
        'Nube': 'Nuvem',
        'Otra': 'Outra',
        'Otro': 'Outro',
        'OTRO': 'OUTRO',
        'Pato': 'Pato',
        'Peso': 'Peso',
        'Piña': 'Ananás',
        'Puño': 'Punho',
        'Rayo': 'Raio',
        'Reno': 'Rena',
        'Roja': 'Vermelha',
        'Rojo': 'Vermelho',
        'Rosa': 'Rosa',
        'Color': 'Cor',
        'Comba': 'Corda',
        'Forma': 'Forma',
        'Fresa': 'Morango',
        'Gorro': 'Gorro',
        'Hueso': 'Osso',
        'Icono': 'Ícone',
        'Letra': 'Letra',
        'Negra': 'Preta',
        'Negro': 'Preto',
        'Notas': 'Notas',
        'Plata': 'Prata',
        'Pulpo': 'Polvo',
        'Tacón': 'Salto',
        'Texto': 'Texto',
        'Total': 'Total',
        'Verde': 'Verde',
        'Árbol': 'Árvore',
        '1º PTO': '1º lugar',
        '2º PTO': '2º lugar',
        '3º PTO': '3º lugar',
        'Anilla': 'Anilha',
        'Blanca': 'Branca',
        'Blanco': 'Branco',
        'Bronce': 'Bronze',
        'Cactus': 'Cato',
        'Carita': 'Carinha',
        'Cohete': 'Foguete',
        'Concha': 'Concha',
        'Copito': 'Floco',
        'Corona': 'Coroa',
        'Delfín': 'Golfinho',
        'Dorada': 'Dourada',
        'Editar': 'Editar',
        'España': 'Espanha',
        'Estilo': 'Estilo',
        'Flecha': 'Seta',
        'Grande': 'Grande',
        'Italia': 'Itália',
        'Marrón': 'Castanho',
        'Modelo': 'Modelo',
        'Morada': 'Roxa',
        'Morado': 'Roxo',
        'Nombre': 'Nome',
        'Pareja': 'Casal',
        'Sandía': 'Melancia',
        'Tamaño': 'Tamanho',
        'Trébol': 'Trevo',
        'Agotado': 'Esgotado',
        'Ballena': 'Baleia',
        'Bandera': 'Bandeira',
        'Cerveza': 'Cerveja',
        'Chupete': 'Chupeta',
        'Ciruela': 'Ameixa',
        'Colores': 'Cores',
        'Corazón': 'Coração',
        'Francia': 'França',
        'Galicia': 'Galiza',
        'Galleta': 'Bolacha',
        'Iguales': 'Iguais',
        'Lobezno': 'Wolverine',
        'Naranja': 'Laranja',
        'Palmera': 'Palmeira',
        'Pequeña': 'Pequena',
        'Pequeño': 'Pequeno',
        'Plátano': 'Banana',
        'Puñitos': 'Punhozinhos',
        'Redondo': 'Redondo',
        'Resumen': 'Resumo',
        'Texto 1': 'Texto 1',
        'Texto 2': 'Texto 2',
        'Texto 3': 'Texto 3',
        'Texto 4': 'Texto 4',
        'Texto 5': 'Texto 5',
        'Texto 6': 'Texto 6',
        'Texto 7': 'Texto 7',
        'Texto 8': 'Texto 8',
        'Texto 9': 'Texto 9',
        'Tiburón': 'Tubarão',
        'Aguacate': 'Abacate',
        'Amarilla': 'Amarela',
        'Amarillo': 'Amarelo',
        'Cabeza A': 'Cabeça A',
        'Cabeza B': 'Cabeça B',
        'Calabaza': 'Abóbora',
        'Cataluña': 'Catalunha',
        'Chip NFC': 'Chip NFC',
        'Cuadrado': 'Quadrado',
        'Estrella': 'Estrela',
        'Estándar': 'Padrão',
        'Nombre 1': 'Nome 1',
        'Nombre 2': 'Nome 2',
        'Objetivo': 'Objetivo',
        'Plateada': 'Prateada',
        'Texto 10': 'Texto 10',
        'Tu charm': 'O teu charm',
        'TU TEXTO': 'O TEU TEXTO',
        'Turquesa': 'Turquesa',
        'Andalucía': 'Andaluzia',
        'Azul cian': 'Azul ciano',
        'Clave sol': 'Clave de sol',
        'Feminista': 'Feminista',
        'Gafas sol': 'Óculos de sol',
        'Gris 36KG': 'Cinzento 36KG',
        'Iniciales': 'Iniciais',
        'Marihuana': 'Cannabis',
        'Rojo 32KG': 'Vermelho 32KG',
        'Rosa palo': 'Rosa pálido',
        'Zanahoria': 'Cenoura',
        'Azul cielo': 'Azul céu',
        'Diferentes': 'Diferentes',
        'Individual': 'Individual',
        'Murciélago': 'Morcego',
        'País Vasco': 'País Basco',
        'Superhéroe': 'Super-herói',
        'Texto base': 'Texto da base',
        'Texto tapa': 'Texto da tampa',
        'Azul oscuro': 'Azul escuro',
        'Blanco 40KG': 'Branco 40KG',
        'Cabezas A/B': 'Cabeças A/B',
        'Color letra': 'Cor da letra',
        'Morado 20KG': 'Roxo 20KG',
        'Peso+Nombre': 'Peso+Nome',
        'Pintalabios': 'Batom',
        'Rosa fucsia': 'Rosa fúcsia',
        'Rosa sakura': 'Rosa sakura',
        'Texto/frase': 'Texto/frase',
        'Verde bambú': 'Verde bambu',
        'Verde menta': 'Verde menta',
        'Ciruela 32KG': 'Ameixa 32KG',
        'Color ribete': 'Cor do rebordo',
        'Flecha Verde': 'Arqueiro Verde',
        'Marrón latte': 'Castanho latte',
        'Naranja 28KG': 'Laranja 28KG',
        'Personalizar': 'Personalizar',
        'Púrpura lila': 'Roxo lilás',
        'Amarillo 16KG': 'Amarelo 16KG',
        'Azul turquesa': 'Azul turquesa',
        'Color mitad 1': 'Cor metade 1',
        'Color mitad 2': 'Cor metade 2',
        'MUJER + MUJER': 'MULHER + MULHER',
        'Parte trasera': 'Parte de trás',
        'Texto mitad 1': 'Texto metade 1',
        'Texto mitad 2': 'Texto metade 2',
        'Texto trasero': 'Texto de trás',
        'Turquesa 12KG': 'Turquesa 12KG',
        'Amarillo limón': 'Amarelo limão',
        'Azul cian 12KG': 'Azul ciano 12KG',
        'Base del mango': 'Base do cabo',
        'Color del logo': 'Cor do logótipo',
        'Elegir archivo': 'Escolher ficheiro',
        'Linterna Verde': 'Lanterna Verde',
        'MUJER + HOMBRE': 'MULHER + HOMEM',
        'Rojo escarlata': 'Vermelho escarlate',
        'Rosa Brillante': 'Rosa brilhante',
        'Texto inferior': 'Texto inferior',
        'Texto superior': 'Texto superior',
        'Verde muérdago': 'Verde visco',
        'Verde turquesa': 'Verde turquesa',
        'Campo requerido': 'Campo obrigatório',
        'Capitán América': 'Capitão América',
        'Color del icono': 'Cor do ícone',
        'Color del texto': 'Cor do texto',
        'HOMBRE + HOMBRE': 'HOMEM + HOMEM',
        'Imagen del logo': 'Imagem do logótipo',
        'Max. 1 caracter': 'Máx. 1 carácter',
        'Max. 2 caracter': 'Máx. 2 caracteres',
        'Parte delantera': 'Parte da frente',
        'Rosa fucsia 8KG': 'Rosa fúcsia 8KG',
        'Rosa sakura 8KG': 'Rosa sakura 8KG',
        'Texto delantero': 'Texto da frente',
        'Verde Brillante': 'Verde brilhante',
        'Verde brillante': 'Verde brilhante',
        'Azul oscuro 12KG': 'Azul escuro 12KG',
        'Color de la base': 'Cor da base',
        'Color del cuerpo': 'Cor do corpo',
        'Elige tu opción:': 'Escolhe a tua opção:',
        'Estilo del texto': 'Estilo do texto',
        'Forma del cuerpo': 'Forma do corpo',
        'Galicia Estelada': 'Galiza Estelada',
        'Verde bambú 24KG': 'Verde bambu 24KG',
        'Verde menta 24KG': 'Verde menta 24KG',
        'Max. 2 caracteres': 'Máx. 2 caracteres',
        'Max. 3 caracteres': 'Máx. 3 caracteres',
        'Max. 6 caracteres': 'Máx. 6 caracteres',
        'Max. 7 caracteres': 'Máx. 7 caracteres',
        'Max. 8 caracteres': 'Máx. 8 caracteres',
        'Max. 9 caracteres': 'Máx. 9 caracteres',
        'Máx. 3 caracteres': 'Máx. 3 caracteres',
        'Máx. 7 caracteres': 'Máx. 7 caracteres',
        'Naranja mandarina': 'Laranja tangerina',
        'Nombre del peludo': 'Nome do peludo',
        'Especifica el peso': 'Especifica o peso',
        'Max. 10 caracteres': 'Máx. 10 caracteres',
        'Max. 12 caracteres': 'Máx. 12 caracteres',
        'Max. 20 caracteres': 'Máx. 20 caracteres',
        'Máx. 12 caracteres': 'Máx. 12 caracteres',
        'Máx. 50 caracteres': 'Máx. 50 caracteres',
        'Número de teléfono': 'Número de telefone',
        'Peso personalizado': 'Peso personalizado',
        'Precio del producto': 'Preço do produto',
        'Texto personalizado': 'Texto personalizado',
        'Iniciales o números.': 'Iniciais ou números.',
        'Texto/nombre trasero': 'Texto/nome de trás',
        '¿Quieres más charms?': 'Queres mais charms?',
        'Texto/nombre delantero': 'Texto/nome da frente',
        'Una letra o un número.': 'Uma letra ou um número.',
        'Forma del marco del ojo': 'Forma da moldura do olho',
        '¿Qué icono te gustaría?': 'Que ícone gostarias?',
        'Peso/color personalizado': 'Peso/cor personalizado',
        'El texto irá en mayúsculas': 'O texto será em maiúsculas',
        'Situado bajo el código QR.': 'Situado sob o código QR.',
        'Tus iniciales o un número.': 'As tuas iniciais ou um número.',
        'Personalización / Adaptación': 'Personalização / Adaptação',
        '¡Un charm para cada ocasión!': 'Um charm para cada ocasião!',
        '¿Quieres colores diferentes?': 'Queres cores diferentes?',
        '¿Quieres otro par de discos?': 'Queres outro par de discos?',
        'Foto, ilustración o referencia': 'Foto, ilustração ou referência',
        'Un nombre, nombre del equipo...': 'Um nome, nome da equipa...',
        'Sube el logo de tu empresa/marca': 'Carrega o logótipo da tua empresa/marca',
        '¿Quieres personalizar tu lloratida?': 'Queres personalizar a tua “lloradita”?',
        '¡Personalízalos! Pueden ser diferentes.': 'Personaliza-os! Podem ser diferentes.',
        '¿Quieres texto encima y debajo de tu marca?': 'Queres texto acima e abaixo da tua marca?',
        'Grabado en la parte de atrás, sobre el color.': 'Gravado na parte de trás, sobre a cor.',
        'Selecciona el color en el que irá la inicial.': 'Seleciona a cor em que vai a inicial.',
        'El nombre irá en la parte trasera de la kettlel.': 'O nome vai na parte de trás da kettlebell.',
        'Enlace a tu web, red social, WhatsApp, llamada...': 'Ligação para o teu site, rede social, WhatsApp, chamada...',
        'Cuéntanos cualquier detalle sobre tu diseño (opcional)': 'Conta-nos qualquer detalhe sobre o teu design (opcional)',
        'Impreso en la parte de atrás de la inicial, bien visible.': 'Impresso na parte de trás da inicial, bem visível.',
        'El nombre irá bajo relieve en la parte delantera de la inicial.': 'O nome ficará em relevo na parte da frente da inicial.',
        'Elige si quieres un llavero individual o un set para compartir.': 'Escolhe se queres um porta-chaves individual ou um set para partilhar.',
        '👉 Puedes enviarnos cualquier imagen o idea. Nosotros la adaptamos.': 'Podes enviar-nos qualquer imagem ou ideia. Nós adaptamos.',
        'Selecciona si las dos caras del disco son iguales o quieres textos diferentes.': 'Seleciona se as duas faces do disco são iguais ou queres textos diferentes.',
        'Incluye 2 charms a tu gusto. ¿Quieres más? ¡Elige los que quieras y hazlo único!': 'Inclui 2 charms à tua escolha. Queres mais? Escolhe os que quiseres e torna-o único!',
        'Icono simple y claro, pensado para identificarse de un vistazo, como los anteriores.': 'Ícone simples e claro, pensado para se identificar de relance, como os anteriores.',
        'El color condiciona el peso, si quieres un peso diferente, elige "Peso personalizado".': 'A cor condiciona o peso; se quiseres um peso diferente, escolhe "Peso personalizado".',
        'Importante: Por motivos de calidad de la pieza, el logo ha de ser lo más simple posible.': 'Importante: Por motivos de qualidade da peça, o logótipo deve ser o mais simples possível.',
        'Selecciona si las dos cabezas de la dumbbell son iguales o quieres iniciales diferentes.': 'Seleciona se as duas cabeças da dumbbell são iguais ou queres iniciais diferentes.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.': 'Escreve a ligação da tua página web, rede social, número de telefone ou morada do negócio.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.<br><br>': 'Escreve a ligação da tua página web, rede social, número de telefone ou morada do negócio.<br><br>',
        'El color condiciona el peso, si quieres un peso diferente u otros colores, selecciona "Sí" en "Peso/color personalizado".': 'A cor condiciona o peso; se quiseres um peso diferente ou outras cores, seleciona "Sim" em "Peso/cor personalizado".',
        '¿Quieres el mismo texto para todos los posavasos con los discos de haltero estándar  o por el contrario quieres tus posavasos custom total?': 'Queres o mesmo texto para todos os bases com os discos de haltero padrão ou preferes bases totalmente custom?',
        'Con la tecnología NFC solo necesitas balancear este llavero cerca de tu móvil y ¡zas! Comparte tu página web, tu red social, tu número de teléfono o dirección.': 'Com a tecnologia NFC só precisas aproximar este porta-chaves do telemóvel e pronto! Partilha a tua página web, rede social, número de telefone ou morada.',
      },
    },
    de: {
      cart_edit_text: 'Bearbeiten',
      price_prefix: 'Ab',
      options_price_label: 'Personalisierung / Anpassung',
      product_group_sold_out_text: 'Ausverkauft',
      add_to_cart_text: 'Personalisieren',
      strings: {
        file_button_text: 'Datei wählen',
        file_placeholder: '{count} Dateien',
        file_droppable_action_text: 'Durchsuchen',
        file_droppable_desc_text: 'oder {action}, um eine Datei zu wählen',
        file_droppable_text: 'Dateien hierher ziehen',
        file_upload_completed: 'Abgeschlossen',
        other: 'Sonstiges',
        clearSelection: 'Löschen',
        repeater_add: 'Feld hinzufügen',
        repeater_remove: 'Feld entfernen',
        add_to_cart_text: 'Personalisieren',
      },
      validation_messages: {
        formError: 'Bitte korrigiere die oben angezeigten Fehler',
        patternError: 'Muster stimmt nicht überein',
        groupMaxError: 'Maximalwert ist %s',
        groupMinError: 'Minimalwert ist %s',
        maxValueError: 'Maximalwert ist %s',
        minValueError: 'Minimalwert ist %s',
        requiredError: 'Pflichtfeld',
        uploadPending: 'Dateien werden noch hochgeladen',
        validUrlError: 'Bitte gib eine gültige URL an',
        maxFieldsError: 'Maximal %s Felder auswählen',
        maxlengthError: 'Maximal %s Zeichen erlaubt',
        minFieldsError: 'Mindestens %s Felder auswählen',
        minlengthError: 'Mindestens %s Zeichen erforderlich',
        charleftMessage: '%s Zeichen übrig',
        otherFieldError: 'Weiterer Wert erforderlich',
        validEmailError: 'Bitte gib eine gültige E-Mail-Adresse an',
        maxFileSizeError: 'Maximale Dateigröße muss %s sein',
        maxQuantityError: 'Maximal erlaubte Menge: %s',
        minFileSizeError: 'Minimale Dateigröße muss %s sein',
        minQuantityError: 'Mindestmenge erforderlich: %s',
        allowedCharsError: 'Zeichen %s werden nicht unterstützt',
        maxFileCountError: 'Maximal %s Dateien erlaubt',
        minFileCountError: 'Mindestens %s Dateien erforderlich',
        fileExtensionError: 'Dateityp wird nicht unterstützt',
        quantityRequiredError: 'Bitte gib eine gültige Menge ein',
      },
      modal: { save: 'Änderungen speichern', cancel: 'Abbrechen' },
      labels: {
        'No': 'Nein',
        'Sí': 'Ja',
        'SÍ': 'JA',
        'Oro': 'Gold',
        'Azul': 'Blau',
        'Base': 'Basis',
        'Beso': 'Kuss',
        'Flor': 'Blume',
        'Gris': 'Grau',
        'Luna': 'Mond',
        'Nube': 'Wolke',
        'Otra': 'Andere',
        'Otro': 'Andere',
        'OTRO': 'ANDERE',
        'Pato': 'Ente',
        'Peso': 'Gewicht',
        'Piña': 'Ananas',
        'Puño': 'Faust',
        'Rayo': 'Blitz',
        'Reno': 'Rentier',
        'Roja': 'Rot',
        'Rojo': 'Rot',
        'Rosa': 'Rosa',
        'Color': 'Farbe',
        'Comba': 'Springseil',
        'Forma': 'Form',
        'Fresa': 'Erdbeere',
        'Gorro': 'Mütze',
        'Hueso': 'Knochen',
        'Icono': 'Icon',
        'Letra': 'Buchstabe',
        'Negra': 'Schwarz',
        'Negro': 'Schwarz',
        'Notas': 'Notizen',
        'Plata': 'Silber',
        'Pulpo': 'Oktopus',
        'Tacón': 'Stöckelschuh',
        'Texto': 'Text',
        'Total': 'Gesamt',
        'Verde': 'Grün',
        'Árbol': 'Baum',
        '1º PTO': '1. Platz',
        '2º PTO': '2. Platz',
        '3º PTO': '3. Platz',
        'Anilla': 'Ring',
        'Blanca': 'Weiß',
        'Blanco': 'Weiß',
        'Bronce': 'Bronze',
        'Cactus': 'Kaktus',
        'Carita': 'Smiley',
        'Cohete': 'Rakete',
        'Concha': 'Muschel',
        'Copito': 'Schneeflocke',
        'Corona': 'Krone',
        'Delfín': 'Delfin',
        'Dorada': 'Gold',
        'Editar': 'Bearbeiten',
        'España': 'Spanien',
        'Estilo': 'Stil',
        'Flecha': 'Pfeil',
        'Grande': 'Groß',
        'Italia': 'Italien',
        'Marrón': 'Braun',
        'Modelo': 'Modell',
        'Morada': 'Lila',
        'Morado': 'Lila',
        'Nombre': 'Name',
        'Pareja': 'Paar',
        'Sandía': 'Wassermelone',
        'Tamaño': 'Größe',
        'Trébol': 'Kleeblatt',
        'Agotado': 'Ausverkauft',
        'Ballena': 'Wal',
        'Bandera': 'Flagge',
        'Cerveza': 'Bier',
        'Chupete': 'Schnuller',
        'Ciruela': 'Pflaume',
        'Colores': 'Farben',
        'Corazón': 'Herz',
        'Francia': 'Frankreich',
        'Galicia': 'Galicien',
        'Galleta': 'Keks',
        'Iguales': 'Gleich',
        'Lobezno': 'Wolverine',
        'Naranja': 'Orange',
        'Palmera': 'Palme',
        'Pequeña': 'Klein',
        'Pequeño': 'Klein',
        'Plátano': 'Banane',
        'Puñitos': 'Fäustchen',
        'Redondo': 'Rund',
        'Resumen': 'Zusammenfassung',
        'Texto 1': 'Text 1',
        'Texto 2': 'Text 2',
        'Texto 3': 'Text 3',
        'Texto 4': 'Text 4',
        'Texto 5': 'Text 5',
        'Texto 6': 'Text 6',
        'Texto 7': 'Text 7',
        'Texto 8': 'Text 8',
        'Texto 9': 'Text 9',
        'Tiburón': 'Hai',
        'Aguacate': 'Avocado',
        'Amarilla': 'Gelb',
        'Amarillo': 'Gelb',
        'Cabeza A': 'Kopf A',
        'Cabeza B': 'Kopf B',
        'Calabaza': 'Kürbis',
        'Cataluña': 'Katalonien',
        'Chip NFC': 'NFC-Chip',
        'Cuadrado': 'Quadrat',
        'Estrella': 'Stern',
        'Estándar': 'Standard',
        'Nombre 1': 'Name 1',
        'Nombre 2': 'Name 2',
        'Objetivo': 'Ziel',
        'Plateada': 'Silber',
        'Texto 10': 'Text 10',
        'Tu charm': 'Dein Charm',
        'TU TEXTO': 'DEIN TEXT',
        'Turquesa': 'Türkis',
        'Andalucía': 'Andalusien',
        'Azul cian': 'Cyanblau',
        'Clave sol': 'Notenschlüssel',
        'Feminista': 'Feministisch',
        'Gafas sol': 'Sonnenbrille',
        'Gris 36KG': 'Grau 36KG',
        'Iniciales': 'Initialen',
        'Marihuana': 'Cannabis',
        'Rojo 32KG': 'Rot 32KG',
        'Rosa palo': 'Blassrosa',
        'Zanahoria': 'Karotte',
        'Azul cielo': 'Himmelblau',
        'Diferentes': 'Unterschiedlich',
        'Individual': 'Einzeln',
        'Murciélago': 'Fledermaus',
        'País Vasco': 'Baskenland',
        'Superhéroe': 'Superheld',
        'Texto base': 'Basistext',
        'Texto tapa': 'Deckeltext',
        'Azul oscuro': 'Dunkelblau',
        'Blanco 40KG': 'Weiß 40KG',
        'Cabezas A/B': 'Köpfe A/B',
        'Color letra': 'Buchstabenfarbe',
        'Morado 20KG': 'Lila 20KG',
        'Peso+Nombre': 'Gewicht+Name',
        'Pintalabios': 'Lippenstift',
        'Rosa fucsia': 'Fuchsia-Rosa',
        'Rosa sakura': 'Sakura-Rosa',
        'Texto/frase': 'Text/Satz',
        'Verde bambú': 'Bambusgrün',
        'Verde menta': 'Mintgrün',
        'Ciruela 32KG': 'Pflaume 32KG',
        'Color ribete': 'Randfarbe',
        'Flecha Verde': 'Green Arrow',
        'Marrón latte': 'Lattebraun',
        'Naranja 28KG': 'Orange 28KG',
        'Personalizar': 'Personalisieren',
        'Púrpura lila': 'Fliederlila',
        'Amarillo 16KG': 'Gelb 16KG',
        'Azul turquesa': 'Türkisblau',
        'Color mitad 1': 'Farbe Hälfte 1',
        'Color mitad 2': 'Farbe Hälfte 2',
        'MUJER + MUJER': 'FRAU + FRAU',
        'Parte trasera': 'Rückseite',
        'Texto mitad 1': 'Text Hälfte 1',
        'Texto mitad 2': 'Text Hälfte 2',
        'Texto trasero': 'Rückseitentext',
        'Turquesa 12KG': 'Türkis 12KG',
        'Amarillo limón': 'Zitronengelb',
        'Azul cian 12KG': 'Cyanblau 12KG',
        'Base del mango': 'Griffbasis',
        'Color del logo': 'Logofarbe',
        'Elegir archivo': 'Datei wählen',
        'Linterna Verde': 'Green Lantern',
        'MUJER + HOMBRE': 'FRAU + MANN',
        'Rojo escarlata': 'Scharlachrot',
        'Rosa Brillante': 'Knallrosa',
        'Texto inferior': 'Unterer Text',
        'Texto superior': 'Oberer Text',
        'Verde muérdago': 'Mistelgrün',
        'Verde turquesa': 'Türkisgrün',
        'Campo requerido': 'Pflichtfeld',
        'Capitán América': 'Captain America',
        'Color del icono': 'Iconfarbe',
        'Color del texto': 'Textfarbe',
        'HOMBRE + HOMBRE': 'MANN + MANN',
        'Imagen del logo': 'Logo-Bild',
        'Max. 1 caracter': 'Max. 1 Zeichen',
        'Max. 2 caracter': 'Max. 2 Zeichen',
        'Parte delantera': 'Vorderseite',
        'Rosa fucsia 8KG': 'Fuchsia-Rosa 8KG',
        'Rosa sakura 8KG': 'Sakura-Rosa 8KG',
        'Texto delantero': 'Vorderseitentext',
        'Verde Brillante': 'Knallgrün',
        'Verde brillante': 'Knallgrün',
        'Azul oscuro 12KG': 'Dunkelblau 12KG',
        'Color de la base': 'Basisfarbe',
        'Color del cuerpo': 'Körperfarbe',
        'Elige tu opción:': 'Wähle deine Option:',
        'Estilo del texto': 'Textstil',
        'Forma del cuerpo': 'Körperform',
        'Galicia Estelada': 'Galicien Estelada',
        'Verde bambú 24KG': 'Bambusgrün 24KG',
        'Verde menta 24KG': 'Mintgrün 24KG',
        'Max. 2 caracteres': 'Max. 2 Zeichen',
        'Max. 3 caracteres': 'Max. 3 Zeichen',
        'Max. 6 caracteres': 'Max. 6 Zeichen',
        'Max. 7 caracteres': 'Max. 7 Zeichen',
        'Max. 8 caracteres': 'Max. 8 Zeichen',
        'Max. 9 caracteres': 'Max. 9 Zeichen',
        'Máx. 3 caracteres': 'Max. 3 Zeichen',
        'Máx. 7 caracteres': 'Max. 7 Zeichen',
        'Naranja mandarina': 'Mandarinenorange',
        'Nombre del peludo': 'Name des Fellnasen',
        'Especifica el peso': 'Gib das Gewicht an',
        'Max. 10 caracteres': 'Max. 10 Zeichen',
        'Max. 12 caracteres': 'Max. 12 Zeichen',
        'Max. 20 caracteres': 'Max. 20 Zeichen',
        'Máx. 12 caracteres': 'Max. 12 Zeichen',
        'Máx. 50 caracteres': 'Max. 50 Zeichen',
        'Número de teléfono': 'Telefonnummer',
        'Peso personalizado': 'Individuelles Gewicht',
        'Precio del producto': 'Produktpreis',
        'Texto personalizado': 'Individueller Text',
        'Iniciales o números.': 'Initialen oder Zahlen.',
        'Texto/nombre trasero': 'Rückseite Text/Name',
        '¿Quieres más charms?': 'Möchtest du mehr Charms?',
        'Texto/nombre delantero': 'Vorderseite Text/Name',
        'Una letra o un número.': 'Ein Buchstabe oder eine Zahl.',
        'Forma del marco del ojo': 'Augenrahmenform',
        '¿Qué icono te gustaría?': 'Welches Icon möchtest du?',
        'Peso/color personalizado': 'Individuelles Gewicht/Farbe',
        'El texto irá en mayúsculas': 'Der Text erscheint in Großbuchstaben',
        'Situado bajo el código QR.': 'Unter dem QR-Code platziert.',
        'Tus iniciales o un número.': 'Deine Initialen oder eine Zahl.',
        'Personalización / Adaptación': 'Personalisierung / Anpassung',
        '¡Un charm para cada ocasión!': 'Ein Charm für jeden Anlass!',
        '¿Quieres colores diferentes?': 'Möchtest du unterschiedliche Farben?',
        '¿Quieres otro par de discos?': 'Möchtest du ein weiteres Scheibenpaar?',
        'Foto, ilustración o referencia': 'Foto, Illustration oder Referenz',
        'Un nombre, nombre del equipo...': 'Ein Name, Teamname...',
        'Sube el logo de tu empresa/marca': 'Lade das Logo deiner Firma/Marke hoch',
        '¿Quieres personalizar tu lloratida?': 'Möchtest du deine „lloradita“ personalisieren?',
        '¡Personalízalos! Pueden ser diferentes.': 'Personalisier sie! Sie können unterschiedlich sein.',
        '¿Quieres texto encima y debajo de tu marca?': 'Möchtest du Text über und unter deiner Marke?',
        'Grabado en la parte de atrás, sobre el color.': 'Auf der Rückseite graviert, über der Farbe.',
        'Selecciona el color en el que irá la inicial.': 'Wähle die Farbe für den Initialbuchstaben.',
        'El nombre irá en la parte trasera de la kettlel.': 'Der Name kommt auf die Rückseite der Kettlebell.',
        'Enlace a tu web, red social, WhatsApp, llamada...': 'Link zu deiner Website, Social Media, WhatsApp, Anruf...',
        'Cuéntanos cualquier detalle sobre tu diseño (opcional)': 'Erzähl uns Details zu deinem Design (optional)',
        'Impreso en la parte de atrás de la inicial, bien visible.': 'Auf der Rückseite des Initialbuchstabens gedruckt, gut sichtbar.',
        'El nombre irá bajo relieve en la parte delantera de la inicial.': 'Der Name wird erhaben auf der Vorderseite des Initialbuchstabens angebracht.',
        'Elige si quieres un llavero individual o un set para compartir.': 'Wähle, ob du einen einzelnen Schlüsselanhänger oder ein Set zum Teilen möchtest.',
        '👉 Puedes enviarnos cualquier imagen o idea. Nosotros la adaptamos.': 'Du kannst uns jedes Bild oder jede Idee senden. Wir passen es an.',
        'Selecciona si las dos caras del disco son iguales o quieres textos diferentes.': 'Wähle, ob beide Seiten der Scheibe gleich sind oder du unterschiedliche Texte möchtest.',
        'Incluye 2 charms a tu gusto. ¿Quieres más? ¡Elige los que quieras y hazlo único!': 'Enthält 2 Charms nach Wahl. Willst du mehr? Wähle so viele du magst und mach ihn einzigartig!',
        'Icono simple y claro, pensado para identificarse de un vistazo, como los anteriores.': 'Einfaches, klares Icon, das auf einen Blick erkennbar ist – wie die vorherigen.',
        'El color condiciona el peso, si quieres un peso diferente, elige "Peso personalizado".': 'Die Farbe bestimmt das Gewicht; wenn du ein anderes Gewicht möchtest, wähle „Individuelles Gewicht“.',
        'Importante: Por motivos de calidad de la pieza, el logo ha de ser lo más simple posible.': 'Wichtig: Aus Qualitätsgründen muss das Logo so einfach wie möglich sein.',
        'Selecciona si las dos cabezas de la dumbbell son iguales o quieres iniciales diferentes.': 'Wähle, ob beide Hantelköpfe gleich sind oder du unterschiedliche Initialen möchtest.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.': 'Gib den Link zu deiner Website, deinem Social-Profil, deine Telefonnummer oder Geschäftsadresse ein.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.<br><br>': 'Gib den Link zu deiner Website, deinem Social-Profil, deine Telefonnummer oder Geschäftsadresse ein.<br><br>',
        'El color condiciona el peso, si quieres un peso diferente u otros colores, selecciona "Sí" en "Peso/color personalizado".': 'Die Farbe bestimmt das Gewicht; wenn du ein anderes Gewicht oder andere Farben möchtest, wähle „Ja“ unter „Individuelles Gewicht/Farbe“.',
        '¿Quieres el mismo texto para todos los posavasos con los discos de haltero estándar  o por el contrario quieres tus posavasos custom total?': 'Möchtest du denselben Text auf allen Untersetzern mit Standard-Hantelscheiben – oder komplett individuelle Untersetzer?',
        'Con la tecnología NFC solo necesitas balancear este llavero cerca de tu móvil y ¡zas! Comparte tu página web, tu red social, tu número de teléfono o dirección.': 'Mit NFC hältst du diesen Anhänger einfach an dein Handy – und zack! Teile Website, Social Profile, Telefonnummer oder Adresse.',
      },
    },
    fr: {
      cart_edit_text: 'Modifier',
      price_prefix: 'À partir de',
      options_price_label: 'Personnalisation / Adaptation',
      product_group_sold_out_text: 'Épuisé',
      add_to_cart_text: 'Personnaliser',
      strings: {
        file_button_text: 'Choisir un fichier',
        file_placeholder: '{count} fichiers',
        file_droppable_action_text: 'Parcourir',
        file_droppable_desc_text: 'ou {action} pour choisir un fichier',
        file_droppable_text: 'Glisse-dépose les fichiers ici',
        file_upload_completed: 'Terminé',
        other: 'Autre',
        clearSelection: 'Effacer',
        repeater_add: 'Ajouter un champ',
        repeater_remove: 'Supprimer le champ',
        add_to_cart_text: 'Personnaliser',
      },
      validation_messages: {
        formError: 'Corrige les erreurs affichées ci-dessus',
        patternError: 'Le modèle ne correspond pas',
        groupMaxError: 'La valeur maximale est %s',
        groupMinError: 'La valeur minimale est %s',
        maxValueError: 'La valeur maximale est %s',
        minValueError: 'La valeur minimale est %s',
        requiredError: 'Champ obligatoire',
        uploadPending: 'Les fichiers sont encore en cours de téléversement',
        validUrlError: 'Fournis une URL valide',
        maxFieldsError: 'Sélectionne au maximum %s champs',
        maxlengthError: '%s caractères maximum autorisés',
        minFieldsError: 'Sélectionne au minimum %s champs',
        minlengthError: 'Au moins %s caractères requis',
        charleftMessage: '%s caractères restants',
        otherFieldError: 'Une autre valeur est requise',
        validEmailError: 'Fournis une adresse e-mail valide',
        maxFileSizeError: 'La taille maximale du fichier doit être %s',
        maxQuantityError: 'Quantité maximale autorisée : %s',
        minFileSizeError: 'La taille minimale du fichier doit être %s',
        minQuantityError: 'Quantité minimale requise : %s',
        allowedCharsError: 'Les caractères %s ne sont pas pris en charge',
        maxFileCountError: 'Maximum %s fichiers autorisés',
        minFileCountError: 'Minimum %s fichiers requis',
        fileExtensionError: 'Type de fichier non pris en charge',
        quantityRequiredError: 'Saisis une quantité valide',
      },
      modal: { save: 'Enregistrer', cancel: 'Annuler' },
      labels: {
        'No': 'Non',
        'Sí': 'Oui',
        'SÍ': 'OUI',
        'Oro': 'Or',
        'Azul': 'Bleu',
        'Base': 'Base',
        'Beso': 'Baiser',
        'Flor': 'Fleur',
        'Gris': 'Gris',
        'Luna': 'Lune',
        'Nube': 'Nuage',
        'Otra': 'Autre',
        'Otro': 'Autre',
        'OTRO': 'AUTRE',
        'Pato': 'Canard',
        'Peso': 'Poids',
        'Piña': 'Ananas',
        'Puño': 'Poing',
        'Rayo': 'Éclair',
        'Reno': 'Renne',
        'Roja': 'Rouge',
        'Rojo': 'Rouge',
        'Rosa': 'Rose',
        'Color': 'Couleur',
        'Comba': 'Corde à sauter',
        'Forma': 'Forme',
        'Fresa': 'Fraise',
        'Gorro': 'Bonnet',
        'Hueso': 'Os',
        'Icono': 'Icône',
        'Letra': 'Lettre',
        'Negra': 'Noir',
        'Negro': 'Noir',
        'Notas': 'Notes',
        'Plata': 'Argent',
        'Pulpo': 'Poulpe',
        'Tacón': 'Talon',
        'Texto': 'Texte',
        'Total': 'Total',
        'Verde': 'Vert',
        'Árbol': 'Arbre',
        '1º PTO': '1re place',
        '2º PTO': '2e place',
        '3º PTO': '3e place',
        'Anilla': 'Anneau',
        'Blanca': 'Blanc',
        'Blanco': 'Blanc',
        'Bronce': 'Bronze',
        'Cactus': 'Cactus',
        'Carita': 'Smiley',
        'Cohete': 'Fusée',
        'Concha': 'Coquillage',
        'Copito': 'Flocon',
        'Corona': 'Couronne',
        'Delfín': 'Dauphin',
        'Dorada': 'Dorée',
        'Editar': 'Modifier',
        'España': 'Espagne',
        'Estilo': 'Style',
        'Flecha': 'Flèche',
        'Grande': 'Grand',
        'Italia': 'Italie',
        'Marrón': 'Marron',
        'Modelo': 'Modèle',
        'Morada': 'Violette',
        'Morado': 'Violet',
        'Nombre': 'Nom',
        'Pareja': 'Paire',
        'Sandía': 'Pastèque',
        'Tamaño': 'Taille',
        'Trébol': 'Trèfle',
        'Agotado': 'Épuisé',
        'Ballena': 'Baleine',
        'Bandera': 'Drapeau',
        'Cerveza': 'Bière',
        'Chupete': 'Tétine',
        'Ciruela': 'Prune',
        'Colores': 'Couleurs',
        'Corazón': 'Cœur',
        'Francia': 'France',
        'Galicia': 'Galice',
        'Galleta': 'Biscuit',
        'Iguales': 'Identiques',
        'Lobezno': 'Wolverine',
        'Naranja': 'Orange',
        'Palmera': 'Palmier',
        'Pequeña': 'Petite',
        'Pequeño': 'Petit',
        'Plátano': 'Banane',
        'Puñitos': 'Petits poings',
        'Redondo': 'Rond',
        'Resumen': 'Résumé',
        'Texto 1': 'Texte 1',
        'Texto 2': 'Texte 2',
        'Texto 3': 'Texte 3',
        'Texto 4': 'Texte 4',
        'Texto 5': 'Texte 5',
        'Texto 6': 'Texte 6',
        'Texto 7': 'Texte 7',
        'Texto 8': 'Texte 8',
        'Texto 9': 'Texte 9',
        'Tiburón': 'Requin',
        'Aguacate': 'Avocat',
        'Amarilla': 'Jaune',
        'Amarillo': 'Jaune',
        'Cabeza A': 'Tête A',
        'Cabeza B': 'Tête B',
        'Calabaza': 'Citrouille',
        'Cataluña': 'Catalogne',
        'Chip NFC': 'Puce NFC',
        'Cuadrado': 'Carré',
        'Estrella': 'Étoile',
        'Estándar': 'Standard',
        'Nombre 1': 'Nom 1',
        'Nombre 2': 'Nom 2',
        'Objetivo': 'Objectif',
        'Plateada': 'Argentée',
        'Texto 10': 'Texte 10',
        'Tu charm': 'Ton charm',
        'TU TEXTO': 'TON TEXTE',
        'Turquesa': 'Turquoise',
        'Andalucía': 'Andalousie',
        'Azul cian': 'Bleu cyan',
        'Clave sol': 'Clé de sol',
        'Feminista': 'Féministe',
        'Gafas sol': 'Lunettes de soleil',
        'Gris 36KG': 'Gris 36KG',
        'Iniciales': 'Initiales',
        'Marihuana': 'Cannabis',
        'Rojo 32KG': 'Rouge 32KG',
        'Rosa palo': 'Rose pâle',
        'Zanahoria': 'Carotte',
        'Azul cielo': 'Bleu ciel',
        'Diferentes': 'Différents',
        'Individual': 'Individuel',
        'Murciélago': 'Chauve-souris',
        'País Vasco': 'Pays basque',
        'Superhéroe': 'Superhéros',
        'Texto base': 'Texte de base',
        'Texto tapa': 'Texte du couvercle',
        'Azul oscuro': 'Bleu foncé',
        'Blanco 40KG': 'Blanc 40KG',
        'Cabezas A/B': 'Têtes A/B',
        'Color letra': 'Couleur de la lettre',
        'Morado 20KG': 'Violet 20KG',
        'Peso+Nombre': 'Poids+Nom',
        'Pintalabios': 'Rouge à lèvres',
        'Rosa fucsia': 'Rose fuchsia',
        'Rosa sakura': 'Rose sakura',
        'Texto/frase': 'Texte/phrase',
        'Verde bambú': 'Vert bambou',
        'Verde menta': 'Vert menthe',
        'Ciruela 32KG': 'Prune 32KG',
        'Color ribete': 'Couleur du bord',
        'Flecha Verde': 'Green Arrow',
        'Marrón latte': 'Marron latte',
        'Naranja 28KG': 'Orange 28KG',
        'Personalizar': 'Personnaliser',
        'Púrpura lila': 'Violet lilas',
        'Amarillo 16KG': 'Jaune 16KG',
        'Azul turquesa': 'Bleu turquoise',
        'Color mitad 1': 'Couleur moitié 1',
        'Color mitad 2': 'Couleur moitié 2',
        'MUJER + MUJER': 'FEMME + FEMME',
        'Parte trasera': 'Arrière',
        'Texto mitad 1': 'Texte moitié 1',
        'Texto mitad 2': 'Texte moitié 2',
        'Texto trasero': 'Texte arrière',
        'Turquesa 12KG': 'Turquoise 12KG',
        'Amarillo limón': 'Jaune citron',
        'Azul cian 12KG': 'Bleu cyan 12KG',
        'Base del mango': 'Base de la poignée',
        'Color del logo': 'Couleur du logo',
        'Elegir archivo': 'Choisir un fichier',
        'Linterna Verde': 'Green Lantern',
        'MUJER + HOMBRE': 'FEMME + HOMME',
        'Rojo escarlata': 'Rouge écarlate',
        'Rosa Brillante': 'Rose vif',
        'Texto inferior': 'Texte inférieur',
        'Texto superior': 'Texte supérieur',
        'Verde muérdago': 'Vert gui',
        'Verde turquesa': 'Vert turquoise',
        'Campo requerido': 'Champ obligatoire',
        'Capitán América': 'Captain America',
        'Color del icono': 'Couleur de l’icône',
        'Color del texto': 'Couleur du texte',
        'HOMBRE + HOMBRE': 'HOMME + HOMME',
        'Imagen del logo': 'Image du logo',
        'Max. 1 caracter': 'Max. 1 caractère',
        'Max. 2 caracter': 'Max. 2 caractères',
        'Parte delantera': 'Avant',
        'Rosa fucsia 8KG': 'Rose fuchsia 8KG',
        'Rosa sakura 8KG': 'Rose sakura 8KG',
        'Texto delantero': 'Texte avant',
        'Verde Brillante': 'Vert vif',
        'Verde brillante': 'Vert vif',
        'Azul oscuro 12KG': 'Bleu foncé 12KG',
        'Color de la base': 'Couleur de la base',
        'Color del cuerpo': 'Couleur du corps',
        'Elige tu opción:': 'Choisis ton option :',
        'Estilo del texto': 'Style du texte',
        'Forma del cuerpo': 'Forme du corps',
        'Galicia Estelada': 'Galice Estelada',
        'Verde bambú 24KG': 'Vert bambou 24KG',
        'Verde menta 24KG': 'Vert menthe 24KG',
        'Max. 2 caracteres': 'Max. 2 caractères',
        'Max. 3 caracteres': 'Max. 3 caractères',
        'Max. 6 caracteres': 'Max. 6 caractères',
        'Max. 7 caracteres': 'Max. 7 caractères',
        'Max. 8 caracteres': 'Max. 8 caractères',
        'Max. 9 caracteres': 'Max. 9 caractères',
        'Máx. 3 caracteres': 'Max. 3 caractères',
        'Máx. 7 caracteres': 'Max. 7 caractères',
        'Naranja mandarina': 'Orange mandarine',
        'Nombre del peludo': 'Nom du toutou',
        'Especifica el peso': 'Indique le poids',
        'Max. 10 caracteres': 'Max. 10 caractères',
        'Max. 12 caracteres': 'Max. 12 caractères',
        'Max. 20 caracteres': 'Max. 20 caractères',
        'Máx. 12 caracteres': 'Max. 12 caractères',
        'Máx. 50 caracteres': 'Max. 50 caractères',
        'Número de teléfono': 'Numéro de téléphone',
        'Peso personalizado': 'Poids personnalisé',
        'Precio del producto': 'Prix du produit',
        'Texto personalizado': 'Texte personnalisé',
        'Iniciales o números.': 'Initiales ou numéros.',
        'Texto/nombre trasero': 'Texte/nom arrière',
        '¿Quieres más charms?': 'Tu veux plus de charms ?',
        'Texto/nombre delantero': 'Texte/nom avant',
        'Una letra o un número.': 'Une lettre ou un numéro.',
        'Forma del marco del ojo': 'Forme du contour de l’œil',
        '¿Qué icono te gustaría?': 'Quelle icône souhaites-tu ?',
        'Peso/color personalizado': 'Poids/couleur personnalisé',
        'El texto irá en mayúsculas': 'Le texte sera en majuscules',
        'Situado bajo el código QR.': 'Situé sous le code QR.',
        'Tus iniciales o un número.': 'Tes initiales ou un numéro.',
        'Personalización / Adaptación': 'Personnalisation / Adaptation',
        '¡Un charm para cada ocasión!': 'Un charm pour chaque occasion !',
        '¿Quieres colores diferentes?': 'Tu veux des couleurs différentes ?',
        '¿Quieres otro par de discos?': 'Tu veux une autre paire de disques ?',
        'Foto, ilustración o referencia': 'Photo, illustration ou référence',
        'Un nombre, nombre del equipo...': 'Un nom, nom d’équipe...',
        'Sube el logo de tu empresa/marca': 'Téléverse le logo de ton entreprise/marque',
        '¿Quieres personalizar tu lloratida?': 'Tu veux personnaliser ta « lloradita » ?',
        '¡Personalízalos! Pueden ser diferentes.': 'Personnalise-les ! Ils peuvent être différents.',
        '¿Quieres texto encima y debajo de tu marca?': 'Tu veux du texte au-dessus et en dessous de ta marque ?',
        'Grabado en la parte de atrás, sobre el color.': 'Gravé à l’arrière, sur la couleur.',
        'Selecciona el color en el que irá la inicial.': 'Sélectionne la couleur de l’initiale.',
        'El nombre irá en la parte trasera de la kettlel.': 'Le nom ira à l’arrière de la kettlebell.',
        'Enlace a tu web, red social, WhatsApp, llamada...': 'Lien vers ton site, réseau social, WhatsApp, appel...',
        'Cuéntanos cualquier detalle sobre tu diseño (opcional)': 'Dis-nous tout détail sur ton design (optionnel)',
        'Impreso en la parte de atrás de la inicial, bien visible.': 'Imprimé à l’arrière de l’initiale, bien visible.',
        'El nombre irá bajo relieve en la parte delantera de la inicial.': 'Le nom sera en relief sur l’avant de l’initiale.',
        'Elige si quieres un llavero individual o un set para compartir.': 'Choisis si tu veux un porte-clés individuel ou un set à partager.',
        '👉 Puedes enviarnos cualquier imagen o idea. Nosotros la adaptamos.': 'Tu peux nous envoyer n’importe quelle image ou idée. Nous l’adaptons.',
        'Selecciona si las dos caras del disco son iguales o quieres textos diferentes.': 'Choisis si les deux faces du disque sont identiques ou si tu veux des textes différents.',
        'Incluye 2 charms a tu gusto. ¿Quieres más? ¡Elige los que quieras y hazlo único!': 'Inclut 2 charms de ton choix. Tu en veux plus ? Choisis ceux que tu veux et rends-le unique !',
        'Icono simple y claro, pensado para identificarse de un vistazo, como los anteriores.': 'Icône simple et claire, conçue pour être reconnue d’un coup d’œil, comme les précédentes.',
        'El color condiciona el peso, si quieres un peso diferente, elige "Peso personalizado".': 'La couleur conditionne le poids ; si tu veux un poids différent, choisis « Poids personnalisé ».',
        'Importante: Por motivos de calidad de la pieza, el logo ha de ser lo más simple posible.': 'Important : pour la qualité de la pièce, le logo doit être le plus simple possible.',
        'Selecciona si las dos cabezas de la dumbbell son iguales o quieres iniciales diferentes.': 'Choisis si les deux têtes de l’haltère sont identiques ou si tu veux des initiales différentes.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.': 'Saisis le lien de ton site, réseau social, numéro de téléphone ou adresse professionnelle.',
        'Escribe el enlace de tu página web, de tu red social, tu número de teléfono o la dirección de tu negocio.<br><br>': 'Saisis le lien de ton site, réseau social, numéro de téléphone ou adresse professionnelle.<br><br>',
        'El color condiciona el peso, si quieres un peso diferente u otros colores, selecciona "Sí" en "Peso/color personalizado".': 'La couleur conditionne le poids ; si tu veux un poids différent ou d’autres couleurs, sélectionne « Oui » sous « Poids/couleur personnalisé ».',
        '¿Quieres el mismo texto para todos los posavasos con los discos de haltero estándar  o por el contrario quieres tus posavasos custom total?': 'Tu veux le même texte sur tous les dessous de verre avec disques d’haltéro standard, ou des dessous de verre 100 % custom ?',
        'Con la tecnología NFC solo necesitas balancear este llavero cerca de tu móvil y ¡zas! Comparte tu página web, tu red social, tu número de teléfono o dirección.': 'Avec le NFC, approche ce porte-clés de ton téléphone et hop ! Partage ton site, réseau social, numéro ou adresse.',
      },
    },
  };

  // Alias for ACO path matching quirks (pt-pt vs pt-PT)
  PACKS['pt-pt'] = PACKS['pt-PT'];
  PACKS.pt = PACKS['pt-PT'];

  function activeLocale() {
    const shopifyLocale = window.Shopify?.locale || '';
    const pathSeg = (location.pathname.split('/')[1] || '').trim();
    const fromPath = /^(en|fr|de|pt-pt|pt-PT|pt)$/i.test(pathSeg) ? pathSeg : '';
    const fromTheme = window.wod3dLocale || '';
    return String(fromPath || shopifyLocale || fromTheme || 'es').trim();
  }

  function packFor(locale) {
    const key = String(locale || '').trim();
    return (
      PACKS[key] ||
      PACKS[key.toLowerCase()] ||
      PACKS[key.replace('_', '-')] ||
      null
    );
  }

  function ensureAcoMeta() {
    window.aco_appMeta = window.aco_appMeta || {};
    const meta = window.aco_appMeta;
    meta.translatted_sett = meta.translatted_sett || {};

    Object.keys(PACKS).forEach((loc) => {
      const pack = PACKS[loc];
      meta.translatted_sett[loc] = Object.assign({}, meta.translatted_sett[loc] || {}, {
        cart_edit_text: pack.cart_edit_text,
        price_prefix: pack.price_prefix,
        options_price_label: pack.options_price_label,
        product_group_sold_out_text: pack.product_group_sold_out_text,
        add_to_cart_text: pack.add_to_cart_text,
        strings: Object.assign({}, (meta.translatted_sett[loc] || {}).strings || {}, pack.strings),
        validation_messages: Object.assign(
          {},
          (meta.translatted_sett[loc] || {}).validation_messages || {},
          pack.validation_messages
        ),
      });
    });

    const locale = activeLocale();
    const pack = packFor(locale);
    if (!pack || /^es/i.test(locale)) return;

    // Force active locale even if ACO path/locale match fails.
    meta.cart_edit_text = pack.cart_edit_text;
    meta.price_prefix = pack.price_prefix;
    meta.options_price_label = pack.options_price_label;
    meta.product_group_sold_out_text = pack.product_group_sold_out_text;
    meta.strings = Object.assign({}, meta.strings || {}, pack.strings);
    meta.validation_messages = Object.assign(
      {},
      meta.validation_messages || {},
      pack.validation_messages
    );
  }

  const LABEL_NODE_SEL = [
    '.wcpa_field_label',
    '.wcpa_field_desc',
    '.wcpa_option_desc',
    '.wcpa_option_label',
    '.wcpa_tooltip',
    '.wcpa_selected_items span',
    '.wcpa_price_summary h4',
    '.wcpa_price_summary span',
    '.wcpa_options_total > span',
    '.wcpa_options_total span',
    '.wcpa_radio > label',
    '.wcpa_radio > label > span',
    '.wcpa_checkbox > label',
    '.wcpa_checkbox > label > span',
    '.wcpa_color_label',
    '.wcpa_image_label',
  ].join(', ');

  function applyLabelMap(el, labels) {
    if (!(el instanceof HTMLElement) || !labels) return;
    const raw = (el.childNodes[0] && el.childNodes[0].nodeType === 3
      ? el.childNodes[0].nodeValue
      : el.textContent) || '';
    const key = raw.replace(/\s*\*$/, '').trim();
    if (!labels[key]) return;
    const hasAst = /\*$/.test(raw.trim()) || el.querySelector?.('.wcpa_required_ast');
    if (el.childNodes[0] && el.childNodes[0].nodeType === 3) {
      el.childNodes[0].nodeValue = labels[key] + (hasAst && !el.querySelector('.wcpa_required_ast') ? ' ' : '');
    } else if (!el.querySelector('.wcpa_required_ast')) {
      el.textContent = labels[key];
    } else {
      Array.from(el.childNodes).forEach((node) => {
        if (node.nodeType === 3 && node.nodeValue.trim()) {
          node.nodeValue = labels[key] + ' ';
        }
      });
    }
  }

  function translateAcoDataAttrs(root, labels) {
    const nodes = [];
    if (root instanceof HTMLElement && root.hasAttribute?.('data-wcpa')) nodes.push(root);
    root.querySelectorAll?.('[data-wcpa]')?.forEach((el) => nodes.push(el));
    nodes.forEach((el) => {
      const raw = el.getAttribute('data-wcpa');
      if (!raw || el.dataset.wod3dI18nWcpa === '1') return;
      let data;
      try {
        data = JSON.parse(raw);
      } catch (_) {
        return;
      }
      let changed = false;
      const walk = (obj) => {
        if (!obj || typeof obj !== 'object') return;
        if (Array.isArray(obj)) {
          obj.forEach(walk);
          return;
        }
        ['label', 'desc', 'description', 'tooltip', 'placeholder', 'title'].forEach((k) => {
          const v = obj[k];
          if (typeof v === 'string' && labels[v.trim()]) {
            obj[k] = labels[v.trim()];
            changed = true;
          }
        });
        Object.keys(obj).forEach((k) => walk(obj[k]));
      };
      walk(data);
      if (!changed) return;
      el.setAttribute('data-wcpa', JSON.stringify(data));
      el.dataset.wod3dI18nWcpa = '1';
    });
  }

  function translateTextNodeTargets(root) {
    const locale = activeLocale();
    const pack = packFor(locale);
    if (!pack || /^es/i.test(locale)) return;

    root.querySelectorAll?.('.aco_popup_submit, .aco_popup_cancel, .aco_edit-button, .wcpa_choose_button, .wod3d-dropzone__choose')?.forEach((el) => {
      if (el.classList.contains('aco_popup_submit')) el.textContent = pack.modal.save;
      else if (el.classList.contains('aco_popup_cancel')) el.textContent = pack.modal.cancel;
      else if (el.classList.contains('aco_edit-button')) el.textContent = pack.cart_edit_text;
      else if (el.classList.contains('wcpa_choose_button') || el.classList.contains('wod3d-dropzone__choose')) {
        el.textContent = pack.strings.file_button_text;
      }
    });

    const labels = pack.labels || {};
    // Root itself may be the tooltip/label (querySelectorAll skips the root node).
    if (root instanceof HTMLElement && root.matches?.(LABEL_NODE_SEL)) {
      applyLabelMap(root, labels);
    }
    root.querySelectorAll?.(LABEL_NODE_SEL)?.forEach((el) => applyLabelMap(el, labels));

    // Color/image swatches often expose Spanish names via title/aria-label (tooltip source).
    const attrRoots = [];
    if (root instanceof HTMLElement) attrRoots.push(root);
    root.querySelectorAll?.(
      '[title], [aria-label], .wcpa_color input, .wcpa_image input, .wcpa_color label, .wcpa_image label'
    )?.forEach((el) => attrRoots.push(el));
    attrRoots.forEach((el) => {
      ['title', 'aria-label', 'data-tip', 'data-tooltip'].forEach((attr) => {
        const val = el.getAttribute?.(attr);
        if (!val) return;
        const key = val.trim();
        if (labels[key]) el.setAttribute(attr, labels[key]);
      });
    });

    translateAcoDataAttrs(root, labels);
  }

  function boot() {
    ensureAcoMeta();
    translateTextNodeTargets(document);

    const observer = new MutationObserver((mutations) => {
      ensureAcoMeta();
      for (const m of mutations) {
        if (m.type === 'characterData' && m.target?.parentElement) {
          translateTextNodeTargets(m.target.parentElement);
        }
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          translateTextNodeTargets(node);
        });
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // ACO often boots late
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      ensureAcoMeta();
      translateTextNodeTargets(document);
      if (tries > 40) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
/* wod3d-i18n-build:1793130721 */
